import { useCallback } from "react";
import { useSmartNavigate } from "./useSmartNavigate";

/**
 * Hook to handle menu navigation with fallback to home if no history
 * @param overrideBack - Optional custom back handler
 */
export function useMenuNavigation(overrideBack?: () => void) {
  const navigate = useSmartNavigate();

  return useCallback(() => {
    if (overrideBack) {
      overrideBack();
    } else {
      // If there's no previous page in the session's history stack for this app,
      // navigate to the main page. Otherwise, go back one step.
      if (window.history.state?.idx === 0 || window.history.state === null) {
        navigate("/");
      } else {
        navigate(-1);
      }
    }
  }, [navigate, overrideBack]);
}
